export default "__VITE_ASSET__B837mMUi__"